import { BILLING_CYCLE, isPaidPlan, getPlanById, normalizeBillingCycle } from 'src/config/plans';

export const CHECKOUT_INTENT_KEY = 'agilodonto.checkoutIntent';

function resolvePaidPlan(planId) {
  const plan = getPlanById(planId);
  return plan && isPaidPlan(plan.id) ? plan : null;
}

export function saveCheckoutIntent(planId, cycle) {
  const plan = resolvePaidPlan(planId);
  if (!plan || typeof sessionStorage === 'undefined') return null;
  const intent = {
    planId: plan.id,
    cycle: normalizeBillingCycle(cycle)
  };
  sessionStorage.setItem(CHECKOUT_INTENT_KEY, JSON.stringify(intent));
  return intent;
}

export function readCheckoutIntent() {
  if (typeof sessionStorage === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(CHECKOUT_INTENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const plan = resolvePaidPlan(parsed?.planId);
    if (!plan) return null;
    return {
      planId: plan.id,
      cycle: normalizeBillingCycle(parsed?.cycle)
    };
  } catch (error) {
    return null;
  }
}

export function clearCheckoutIntent() {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.removeItem(CHECKOUT_INTENT_KEY);
}

export function checkoutPath(planId, cycle = BILLING_CYCLE.MONTHLY) {
  const params = new URLSearchParams();
  const plan = resolvePaidPlan(planId);
  if (plan) params.set('plan', plan.id);
  params.set('cycle', normalizeBillingCycle(cycle));
  return `/checkout?${params.toString()}`;
}
